







































import {
  computed, defineComponent, PropType, toRefs,
} from '@nuxtjs/composition-api';

import IBiuroSzczegoly from '~/components/biura/types/IBiuroSzczegoly';

export default defineComponent({
  props: {
    biuro: {
      type: Object as PropType<IBiuroSzczegoly>,
      required: true,
    },
  },
  setup(props, { emit }) {
    const { biuro } = toRefs(props);

    return {
      kodPocztowyIMiejscowosc: computed((): string => `${biuro.value.Miasto} ${biuro.value.KodPocztowy}`),
      toggleMapModal: () => {
        emit('toggleMapModal');
      },
      biuroHasCoords: computed((): boolean => {
        if (!biuro.value) return false;

        return (
          biuro.value.SzerokoscGeo !== null
          && biuro.value.SzerokoscGeo !== undefined
          && biuro.value.DlugoscGeo !== null
          && biuro.value.DlugoscGeo !== undefined
        );
      }),
    };
  },
});
